<template>
  <li
    :class="['local-admin__user-item', { isActive }]"
    @click="clickHandler(user)"
  >
    <div class="local-admin__user-item__user-avatar">
      <div class="local-admin__user-item__user-avatar__image-wrapper">
        <img
          v-if="user && user.avatar"
          :src="getImageSource(user.avatar)"
          class="local-admin__user-item__user-avatar__image"
        />
        <r-icon name="user" :size="12" />
      </div>
    </div>
    <div v-if="user.name" class="local-admin__user-item__user-info">
      <div class="local-admin__user-item__user-info__name">
        <r-text style="font-weight: bold">{{ user.name }}</r-text>
      </div>
      <div
        v-if="user.position"
        class="local-admin__user-item__user-info__description"
      >
        <r-text type="caption" style="font-weight: italic">
          {{ user.position }}
        </r-text>
      </div>
    </div>
  </li>
</template>

<script>
import constants from "@/constants/url";

export default {
  props: { user: Object, clickHandler: Function, isActive: Boolean },
  data() {
    return {
      downloadURL: "download_share_resource",
      baseURL: constants.URL
    };
  },
  methods: {
    getImageSource(file) {
      return `${this.baseURL}/${this.downloadURL}/${file}`;
    }
  }
};
</script>

<style lang="scss">
.local-admin__user-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 52px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border-radius: var(--border-radius);
  border: 1px solid;
  transition: border-color 0.12s ease;
  border-color: var(--dividers_low_contrast) !important;
  background-color: var(--field_bg) !important;
  cursor: pointer;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    border-color: var(--accent_primary) !important;
  }
  &__user {
    &-avatar {
      height: 24px;
      width: 24px;
      overflow: hidden;
      border-radius: 50%;
      position: relative;
      margin-right: 8px;
      &__image {
        height: 100%;
        width: 100%;
        top: 50%;
        left: 50%;
        box-sizing: border-box;
        &-wrapper {
          height: 100%;
          width: 100%;
          background-color: var(--bg_containers) !important;
        }
      }
    }
    &-info {
      height: 100%;
      width: calc(100% - 40px);
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      &__name,
      &__description,
      .r-text,
      .r-text.caption-2 {
        width: 100%;
        text-align: start;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &__description {
        padding-top: 4px;
      }
    }
  }
  &.isActive {
    background-color: var(--accent_selected) !important;
    border: none;
    .local-admin__user-item__user-avatar__image-wrapper {
      background-color: var(--white_white) !important;
      .r-icon__svg {
        fill: var(--accent_info) !important;
      }
    }
  }
}
</style>
